import { useId } from 'react'
import type { InputHTMLAttributes } from 'react'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  /** light = on white content cards (default), dark = on navy screens (login). */
  tone?: 'light' | 'dark'
}

const tones = {
  light: {
    label: 'text-ostrel-ink-muted',
    input:
      'border-ostrel-line bg-ostrel-card text-ostrel-ink placeholder:text-ostrel-ink-muted focus:border-ostrel-gold',
  },
  dark: {
    label: 'text-ostrel-muted',
    input:
      'border-ostrel-border bg-ostrel-navy text-ostrel-light placeholder:text-ostrel-dim focus:border-ostrel-gold',
  },
} as const

export function Input({ label, error, tone = 'light', id, className = '', ...rest }: InputProps) {
  const autoId = useId()
  const inputId = id ?? autoId
  const t = tones[tone]
  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label htmlFor={inputId} className={`text-[10px] font-semibold uppercase tracking-widest ${t.label}`}>
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={`rounded-sm border px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-ostrel-gold disabled:opacity-60 ${t.input} ${className}`}
        {...rest}
      />
      {error && <p className="text-xs text-ostrel-danger">{error}</p>}
    </div>
  )
}
